var jsonDataElement = document.getElementById('filejson_value');
var all_links = JSON.parse(jsonDataElement.textContent);
var variantSKU = document.getElementById("specification-card").dataset.variantSku;
var linkHtml = "";

document.addEventListener('DOMContentLoaded', handleSpecificationCardRender);
document.addEventListener('on:product:change', handleSpecificationCardRender);

function handleSpecificationCardRender() {
    jsonDataElement = document.getElementById('filejson_value');
    all_links = JSON.parse(jsonDataElement.textContent);
    variantSKU = document.getElementById("specification-card").dataset.variantSku;
    linkHtml = "";
    changeProductUI();
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', function (event) {
            const updatedVariant = event.detail.variant;
            //const updatedProduct = event.detail.product;
            if (updatedVariant == null) return;
            variantSKU = updatedVariant.sku;
            changeProductUI();
        });
    }
}

function changeProductUI() {
    if (all_links != null && all_links.length > 0) {
        const link = all_links[0];
        linkHtml = `
              <div class="bottom-border" style="display:flex">
              <div>Datasheet:</div>
              <div style="padding-left:3px;">
                <a  style="color:black;"  href="${
            link.content[0].url
        }" download="SpecSheet({{ selected_variant.sku }})" target="_blank">${variantSKU} Datasheet <i class="fa-solid fa-file-pdf" style="display:inline"></i></a>
                <div style="margin-top:-9px;">
                  <button style="color:gray;" onclick="scrollToDownloads()">view all documents</button>
                </div>
              </div>
              </div>
              <hr class="mt-4 mb-4">
            `;
        document.getElementById("specification-card").innerHTML = linkHtml;
        let linksHtml = all_links?.filter(link => !link.label.includes("Declaration")).map(link => {
            return `
        <p><strong>${
                link.label
            }</strong></p>
        ${
                getContent(link.content)
            }
      `;
        });
        setTimeout(() => renderLinksUnderFileDownload(linksHtml), 500)
    } else {
        setTimeout(() => {
            let aaa = document.querySelectorAll('div.disclosure__content p');
            aaa.forEach(a => {
                if (a.textContent === "::specification::") {
                    a.closest('details-disclosure').style.display = 'none';
                }
            });
        }, 100)
    }
}

function scrollToDownloads() {
    let specificationElement = document.getElementById("spec_sheet_links");
    specificationElement
        .parentElement
        .parentElement
        .parentElement
        .setAttribute("open", "");
    scrollToTargetAdjusted(specificationElement);
}

function renderLinksUnderFileDownload(linksHtml) {
    let aaa = document.querySelectorAll('div.disclosure__content p');
    aaa.forEach(a => {
        if (a.textContent === "::specification::") {
            a.parentElement.innerHTML = `<div id="spec_sheet_links">${
                linksHtml.join("")
            }</div>`
        }
    });
}

// helper functions
function getContent(content) {
    let contentHtml = content?.map(link => {
        return `
        <li>
        <a href="${
            link.url
        }" download="${
            link.name
        }" target="_blank">
          <i class="fa-solid fa-file-pdf" style="display:inline"></i>
          ${
            link.name
        }
        </a>
        </li>
      `
    }).join("");
    contentHtml = "<ul>" + contentHtml + "</ul>";
    return contentHtml;
}

function scrollToTargetAdjusted(element) {
    var headerOffset = 150;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({top: offsetPosition, behavior: "smooth"});
}
